<template>
  <span class="text-xs rounded-lg p-1 mx-1"
    :class="{
      'bg-sky-100': canChange,
      'bg-gray-100': !canChange,
    }">
    {{ displayText }}
    <XButton
      class="p-1 w-4 h-4 bg-red-200 rounded-lg"
      v-if="canChange && canDelete"
      @click="deleteOption"
    />
  </span>
</template>

<script>
import XButton from '../../XButton.vue'

import buildingData from '../../../services/viewData/building.js'
import districtData from '../../../services/viewData/district.js'
import partitionData from '../../../services/viewData/partition.js'
import schoolYearData from '../../../services/viewData/schoolYear.js'
import vendorData from '../../../services/viewData/vendor.js'

import DROPDOWN_LISTS from '../../../components/DropdownLists.json'

const DATA_TYPE_MAP = {
  schoolYear: schoolYearData,
  partition: partitionData,
  district: districtData,
  vendor: vendorData,
  building: buildingData,
}

const DISPLAY_FUNC_MAP = {
  schoolYear: value => DROPDOWN_LISTS.schoolYears[value.code],
  partition: value => value.data.description,
  district: value => value.id,
  vendor: value => value.data.name,
  building: value => value.data.name,
}

export default {
  components: {
    XButton,
  },
  props: {
    id: [String, Number],
    type: String,
    canChange: {
      type: Boolean,
      default: false,
    },
    canDelete: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      displayText: undefined,
      dataPromise: undefined,
    }
  },
  methods: {
    prepareTextData() {
      if (this.dataPromise === undefined) {
        this.displayText = `Loading (${this.id})`
      }

      let dataModule = DATA_TYPE_MAP[this.type]
      this.dataPromise = dataModule.get(this.id)

      this.dataPromise.then(item => {
        if (item === undefined) {
          return
        }

        this.displayText = DISPLAY_FUNC_MAP[this.type](item)
      })
    },
    deleteOption() {
      this.$emit('deleteOption', this.type, this.id)
    },
  },
  mounted() {
    this.prepareTextData()
  },
  watch: {
    id() {
      this.prepareTextData()
    },
    type() {
      this.prepareTextData()
    },
  },
}
</script>
